import { UNIFORM_PROPS } from 'common/constants/component-props';

export const defaultProps = {
	[UNIFORM_PROPS.fileUploadMaxSizeMb]: 25,
};
